import { encode as base64_encode } from 'base-64';
import { postApi, baseURL } from '../components/Utility'
import {
  action,

  makeObservable,
  observable,

} from 'mobx';
import config from "../config";
import { getCached, setCached } from './cacheStore';


class TravelReportStore {
  travelReport = []
  totalStartStopArray = []
  total = 0
  totalTravelReportTotal = 0
  loading = false
  rootStore
  loadingData = false
  pageSize = 0

  constructor(rootStore) {
    makeObservable(this, {
      travelReport: observable,
      pageSize: observable,
      totalStartStopArray: observable,
      total: observable,
      loading: observable,
      loadingData: observable,
      totalTravelReportTotal: observable,
      loadData: action,
      exportExcel: action,
      exportcsv: action,
      exportpdf: action,
      exportxml: action,
      exporttotalexcel: action,
      exporttotalpdf: action,
      totalStartStopReport: action
    });
    this.rootStore = rootStore;

  }

  async loadData({ companyId, offset, limit, vehicleId, driverId, fromDate, toDate, interval, pageNo, filterby, allVehicleIds }) {
    var response
    const cacheKey = `travelreportlist:${companyId}:${vehicleId}:${allVehicleIds}:${fromDate}:${toDate}:${interval}:${offset}:${limit}:${pageNo}`;

    const cached = getCached(cacheKey);

    if (cached) {
      this.total = cached.total;
      this.pageSize = cached.pageSize
      this.travelReport = cached.reportData;
      return;
    }
    this.loading = true;
    var postData = { "companyId": companyId, "vehicleId": vehicleId, "driverId": driverId, "fromDate": fromDate, "toDate": toDate, "interval": interval, "offset": offset, "limit": limit, "page": pageNo, "filterby": filterby }

    if (config.pythonReport === 1) {
      response = await postApi.getClient("report").post("/tracking_report/travel_report", postData);
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      response = await postApi.getClient().post("index.php?c=vehicle&a=startstop", "postData=" + base64Input);
    }

    const reportData = response?.data?.data?.startStopData ?? [];
    const total = parseInt(response?.data?.data?.TotalCount);
    const pageSize = reportData?.length

    setCached(cacheKey, { total, pageSize, reportData });

    this.total = total
    this.travelReport = reportData;
    this.pageSize = pageSize
    this.loading = false;


    // this.total = parseInt(response?.data?.data?.TotalCount);
    // this.travelReport = response?.data?.data?.startStopData
    // this.pageSize = this.travelReport?.length
    // this.loading = false;
  }

  async totalStartStopReport({ offset, limit, companyId, fromDate, toDate, vehicleId, interval, driverId, filterBy, pageNo }) {
    var response
    const cacheKey = `totaltravelreportlist:${companyId}:${vehicleId}${fromDate}:${toDate}:${interval}:${offset}:${limit}:${pageNo}`;
    const cached = getCached(cacheKey);
    if (cached) {
      this.totalTravelReportTotal = cached.total;
      this.totalStartStopArray = cached.reportData;
      return;
    }
    this.loadingData = true
    var postData = { "companyId": companyId, "vehicleId": vehicleId, "fromDate": fromDate, "toDate": toDate, interval: interval, offset: offset, limit: limit, driverId: driverId, filterBy: filterBy, total: true, page: pageNo }

    if (config.pythonReport == 1) {
      response = await postApi.getClient("report").post("/tracking_report/travel_report", postData);
      // this.totalStartStopArray = response?.data?.data?.startStopData
      const reportData = response?.data?.data?.startStopData ?? [];
      const total = parseInt(response?.data?.data?.TotalCount);
      setCached(cacheKey, { reportData, total });

      this.totalTravelReportTotal = total
      this.totalStartStopArray = reportData
      this.loadingData = false;
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      response = await postApi.getClient().post("index.php?c=vehicle&a=totalStartStopRep", "postData=" + base64Input);
      this.totalStartStopArray = response?.data?.data

      this.totaltotalTravelReportTotal = parseInt(response?.data?.data?.TotalCount);
      this.loadingData = false;
    }


  }

  async exportExcel(getData) {

    if (config.pythonReport === 1) {



      try {
        await postApi.getClient("report").post("/tracking_report/travel_report/download/excel", getData, {
          responseType: "blob",
        });
        this.pythonReportMessage = true;
      } catch (error) {
        this.pythonReportErrorMessage = true;
      }

    } else {
      let lang = "english";
      window.location.href =
        baseURL +
        "index.php?c=vehicle&a=exportstartstopexcel2&cid=" +
        getData.companyId +
        "&vid=" +
        getData.vehicleId +
        "&userId=" +
        getData.userId +
        "&filterby=" +
        getData.filterby +
        "&driverId=" +
        getData.driverId +
        "&int=" +
        getData.interval +
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&colList=" +
        getData.colList +
        "&language=" +
        lang;
    }
  }

  async exportcsv(getData) {
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exportstartstopcsv&cid=" +
      getData.companyId +
      "&userId=" +
      getData.userId +
      "&vid=" +
      getData.vehicleId +
      "&int=" +
      getData.interval +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList;
  }

  async exportpdf(getData) {

    if (config.pythonReport === 1) {

      try {
        await postApi.getClient("report").post("/tracking_report/travel_report/download/pdf", getData, {
          responseType: "blob",
        });
        this.pythonReportMessage = true;
      } catch (error) {
        this.pythonReportErrorMessage = true;
      }
    } else {
      let lang = "english";
      window.location.href =
        baseURL +
        "index.php?c=vehicle&a=exportstartstoppdf&cid=" +
        getData.companyId +
        "&userId=" +
        getData.userId +
        "&vid=" +
        getData.vehicleId +
        "&int=" +
        getData.interval +
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&colList=" +
        getData.colList +
        "&language=" +
        lang;
    }
  }

  async exportxml(getData) {
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exportstartstopxml&cid=" +
      getData.companyId +
      "&userId=" +
      getData.userId +
      "&vid=" +
      getData.vehicleId +
      "&int=" +
      getData.interval +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList;
  }
  async exporttotalexcel(getData) {

    if (config.pythonReport === 1) {


      try {
        await postApi.getClient("report").post("/tracking_report/travel_reportTotal/download/excel", getData, {
          responseType: "blob",
        });
        this.pythonReportMessage = true;
      } catch (error) {
        this.pythonReportErrorMessage = true;
      }

    } else {

      let lang = "english";
      window.location.href =
        baseURL +
        "index.php?c=vehicle&a=exportTotalstartstopexcel&cid=" +
        getData.companyId +
        "&userId=" +
        getData.userId +
        "&vid=" +
        getData.vehicleId +
        "&int=" +
        getData.interval +
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&colList=" +
        getData.colList +
        "&language=" +
        lang;
    }
  }
  async exporttotalpdf(getData) {

    if (config.pythonReport === 1) {



      try {
        await postApi.getClient("report").post("/tracking_report/travel_reportTotal/download/pdf", getData, {
          responseType: "blob",
        });
        this.pythonReportMessage = true;
      } catch (error) {
        this.pythonReportErrorMessage = true;
      }

    } else {

      let lang = "english";
      window.location.href =
        baseURL +
        "index.php?c=vehicle&a=exportTotalstartstopPdf&cid=" +
        getData.companyId +
        "&userId=" +
        getData.userId +
        "&vid=" +
        getData.vehicleId +
        "&int=" +
        getData.interval +
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&colList=" +
        getData.colList +
        "&language=" +
        lang;
    }
  }

}

export default TravelReportStore;
